import Table from "../../../Components/Table/Table";
import StatusColorful from "../../../Components/Table/Components/StatusColorful";
import SVG from "../../../Components/SVG";
import Custom from "../../../Components/Buttons/Custom";
import TableLoading from "../../../Components/Loader/TableLoading";
import { useNavigate } from "react-router-dom";
import PercentageValue from "../../../Components/PercentageValue";

const isDefined = (value) => value !== null && value !== undefined && value !== "";
const asNumber = (value) => {
  if (!isDefined(value)) return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};
const percent = (value) => {
  const parsed = asNumber(value);
  return parsed === null ? "-" : (
    <PercentageValue value={parsed} minimumFractionDigits={2} />
  );
};
const days = (value) => {
  const parsed = asNumber(value);
  return parsed === null ? "-" : <bdi dir="ltr">{parsed} روز</bdi>;
};

const statusForRule = (rule, isLive, { target = false } = {}) => {
  if (rule?.violated) return isLive ? "danger" : "failed";
  if (!target) return isLive ? "stable" : "passed";
  const current = asNumber(rule?.current_state);
  const definition = asNumber(rule?.definition);
  if (current !== null && definition !== null && current >= definition) return "passed";
  if (!isLive) return "failed";
  return current !== null && current < 0 ? "danger" : "stable";
};

const statusRenderer = (value) => {
  const states = {
    passed: ["tick", "تکمیل شده", "blue"],
    stable: ["stall", "پایدار", "green"],
    danger: ["danger", "ناپایدار", "yellow"],
    failed: ["failed", "رد شده", "red"],
  };
  const state = states[value];
  return state ? (
    <StatusColorful SVGName={state[0]} text={state[1]} className="w-24" color={state[2]} />
  ) : (
    "-"
  );
};

const columns = [
  { key: "title", label: "عنوان" },
  { key: "current", label: "وضعیت فعلی" },
  { key: "metric", label: "معیار" },
  { key: "status", label: "وضعیت", render: statusRenderer },
];

export default function Missions({ rulesData, ruleLoading }) {
  const navigate = useNavigate();
  const rules = rulesData?.rules ?? {};
  const isLive = rulesData?.status === "live";
  const rows = [];

  const addPercentRule = (key, title, options) => {
    const rule = rules[key];
    if (!isDefined(rule?.definition)) return;
    rows.push({
      title,
      current: percent(rule?.current_state),
      metric: percent(rule?.definition),
      status: statusForRule(rule, isLive, options),
    });
  };

  if ((asNumber(rules.profit_target?.definition) ?? 0) > 0) {
    addPercentRule("profit_target", "سود هدف", { target: true });
  }
  addPercentRule("max_drawdown_limit", "حد ضرر کلی");
  addPercentRule("daily_drawdown_limit", "حد ضرر روزانه");
  addPercentRule("trade_drawdown_limit", "حد ضرر هر معامله");

  const minTradingDays = asNumber(rulesData?.min_trading_days);
  if (minTradingDays !== null && minTradingDays > 0) {
    const tradingDays = asNumber(rulesData?.trading_days) ?? 0;
    rows.push({
      title: "حداقل روزهای معاملاتی",
      current: days(tradingDays),
      metric: days(minTradingDays),
      status:
        tradingDays >= minTradingDays ? "passed" : isLive ? "danger" : "failed",
    });
  }

  addPercentRule("consistency_rule", "حداکثر سود هر روز معاملاتی از سود کل");
  addPercentRule("fast_scalp", "مجموع سود مجاز معاملات اسکلپ");

  return (
    <div className="w-full h-fit flex flex-col p-5 gap-5 rounded-2xl bg-zi-bg2-light dark:bg-zi-bg2-dark overflow-hidden min-h-0">
      <div className="w-full flex justify-between items-center">
        <h2 className="flex gap-2.5 items-center">
          <SVG name="mission" classname="size-5 stroke-zi-blue-dark dark:stroke-white" />
          <span className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
            مأموریت‌های چالش
          </span>
        </h2>
        <Custom
          onClick={() => navigate("/rule/challenge")}
          text="قوانین چالش‌ها"
          href=""
          className="bg-zi-bg2-light dark:bg-zi-bg2-dark !px-5 !py-2 !rounded-full text-zi-text-light dark:text-zi-text-dark ring-1 ring-zi-border-dark dark:ring-zi-border-light hocus:bg-zi-bg1-light hocus:dark:bg-zi-bg1-dark"
        />
      </div>
      <Table isEnglish={[1, 2]} columns={columns} data={ruleLoading ? [] : rows} />
      {ruleLoading && (
        <div className="w-full flex justify-center items-center gap-2">
          <p className="text-[#808080]">در حال بارگذاری</p>
          <TableLoading className="text-[#808080]" />
        </div>
      )}
      {!ruleLoading && rows.length === 0 && (
        <div className="w-full flex justify-center items-center flex-col gap-5">
          <p className="text-zi-text-light dark:text-zi-text-dark">موردی برای نمایش وجود ندارد</p>
          <SVG name="noData" classname="w-24 fill-cyan-500" />
        </div>
      )}
    </div>
  );
}
